var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "headerCheckbox",
      class: { checked: _vm.checked },
      on: { click: _vm.toggle },
    },
    [_c("i", { staticClass: "heart icon" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }